import React, { useState } from 'react';
import { Button } from '../components/ui/Button';
import { Input } from '../components/ui/Input';
import { Card, CardBody, CardHeader } from '../components/ui/Card';
import { Phone, Calendar as CalendarIcon, MapPin, Info } from 'lucide-react';
export function Booking() {
  const [step, setStep] = useState(1);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isSuccess, setIsSuccess] = useState(false);
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    setIsSubmitting(true);
    // Simulate API call
    setTimeout(() => {
      setIsSubmitting(false);
      setIsSuccess(true);
    }, 1500);
  };
  if (isSuccess) {
    return <div className="min-h-screen bg-warm-50 py-20 px-4" data-id="element-239">
        <div className="max-w-2xl mx-auto" data-id="element-240">
          <Card className="text-center py-12" data-id="element-241">
            <CardBody data-id="element-242">
              <div className="w-20 h-20 bg-green-100 text-green-600 rounded-full flex items-center justify-center mx-auto mb-6" data-id="element-243">
                <svg className="w-10 h-10" fill="none" stroke="currentColor" viewBox="0 0 24 24" data-id="element-244">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" data-id="element-245"></path>
                </svg>
              </div>
              <h2 className="text-3xl font-bold text-warm-900 mb-4" data-id="element-246">
                Request Received!
              </h2>
              <p className="text-lg text-warm-600 mb-8" data-id="element-247">
                Thank you for booking with Gozie Transportation. Our dispatch
                team is reviewing your request and will contact you shortly to
                confirm the details and provide an affordable quote.
              </p>
              <Button onClick={() => window.location.href = '/'} data-id="element-248">
                Return to Home
              </Button>
            </CardBody>
          </Card>
        </div>
      </div>;
  }
  return <div className="min-h-screen bg-warm-50 py-12" data-id="element-249">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-250">
        <div className="flex flex-col lg:flex-row gap-8" data-id="element-251">
          {/* Main Form Area */}
          <div className="lg:w-2/3" data-id="element-252">
            <div className="mb-8" data-id="element-253">
              <h1 className="text-3xl font-bold text-warm-900 mb-2" data-id="element-254">
                Schedule Affordable Transportation or Shipping
              </h1>
              <p className="text-warm-600" data-id="element-255">
                Fill out the form below to request a low-cost ride or equipment
                delivery. For immediate needs (within 24 hours), please call us
                directly.
              </p>
            </div>

            <Card data-id="element-256">
              <CardHeader className="bg-white border-b border-warm-200" data-id="element-257">
                <div className="flex items-center justify-between" data-id="element-258">
                  <h2 className="text-xl font-semibold text-warm-900" data-id="element-259">
                    Trip Details
                  </h2>
                  <span className="text-sm font-medium text-primary-600" data-id="element-260">
                    Step {step} of 2
                  </span>
                </div>
              </CardHeader>
              <CardBody data-id="element-261">
                <form onSubmit={step === 1 ? e => {
                e.preventDefault();
                setStep(2);
              } : handleSubmit} data-id="element-262">
                  {step === 1 && <div className="space-y-6 animate-in fade-in slide-in-from-bottom-4 duration-500" data-id="element-263">
                      <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-264">
                        <Input label="Pickup Date" type="date" required data-id="element-265" />
                        <Input label="Pickup Time" type="time" required data-id="element-266" />
                      </div>

                      <div className="space-y-4" data-id="element-267">
                        <Input label="Pickup Address" placeholder="123 Main St, City, State, Zip" required data-id="element-268" />
                        <Input label="Drop-off Address" placeholder="456 Medical Blvd, City, State, Zip" required data-id="element-269" />
                      </div>

                      <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-270">
                        <Input label="Type of Service Needed" options={[{
                      value: 'wheelchair',
                      label: 'Wheelchair Passenger Transport'
                    }, {
                      value: 'shipping',
                      label: 'Mobility Equipment Shipping Only'
                    }, {
                      value: 'scooter',
                      label: 'Power Scooter User'
                    }, {
                      value: 'ambulatory',
                      label: 'Ambulatory (No Device)'
                    }]} required data-id="element-271" />
                        <Input label="Number of Passengers" type="number" min="1" max="5" defaultValue="1" required data-id="element-272" />
                      </div>

                      <div className="pt-4 border-t border-warm-100 flex justify-end" data-id="element-273">
                        <Button type="submit" size="lg" data-id="element-274">
                          Continue to Passenger Details
                        </Button>
                      </div>
                    </div>}

                  {step === 2 && <div className="space-y-6 animate-in fade-in slide-in-from-right-8 duration-500" data-id="element-275">
                      <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-276">
                        <Input label="Passenger First Name" required data-id="element-277" />
                        <Input label="Passenger Last Name" required data-id="element-278" />
                      </div>

                      <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-279">
                        <Input label="Phone Number" type="tel" placeholder="(555) 123-4567" required data-id="element-280" />
                        <Input label="Email Address" type="email" placeholder="email@example.com" required data-id="element-281" />
                      </div>

                      <Input label="Special Requests or Instructions" multiline placeholder="E.g., Needs oxygen tank transport, traveling with a service animal, specific door to use..." data-id="element-282" />

                      <div className="pt-4 border-t border-warm-100 flex justify-between items-center" data-id="element-283">
                        <Button type="button" variant="ghost" onClick={() => setStep(1)} data-id="element-284">
                          Back
                        </Button>
                        <Button type="submit" size="lg" disabled={isSubmitting} data-id="element-285">
                          {isSubmitting ? 'Submitting Request...' : 'Submit Booking Request'}
                        </Button>
                      </div>
                    </div>}
                </form>
              </CardBody>
            </Card>
          </div>

          {/* Sidebar */}
          <div className="lg:w-1/3 space-y-6" data-id="element-286">
            <Card className="bg-white text-warm-900 border-none shadow-lg" data-id="element-287">
              <CardBody className="p-8" data-id="element-288">
                <Phone className="w-10 h-10 text-primary-600 mb-4" data-id="element-289" />
                <h3 className="text-xl font-bold text-warm-900 mb-2" data-id="element-290">
                  Prefer to book by phone?
                </h3>
                <p className="text-warm-600 mb-6" data-id="element-291">
                  Our dispatchers are available 24/7 to take your reservation or
                  answer any questions.
                </p>
                <a href="tel:2404132157" className="block w-full text-center bg-primary-600 text-white font-bold py-3 rounded-lg hover:bg-primary-700 transition-colors" data-id="element-292">
                  Call (240) 413-2157
                </a>
              </CardBody>
            </Card>

            <Card data-id="element-293">
              <CardBody data-id="element-294">
                <h3 className="text-lg font-bold text-warm-900 mb-4 flex items-center" data-id="element-295">
                  <Info className="w-5 h-5 mr-2 text-primary-600" data-id="element-296" />
                  Booking Information
                </h3>
                <ul className="space-y-4 text-sm text-warm-600" data-id="element-297">
                  <li className="flex items-start" data-id="element-298">
                    <CalendarIcon className="w-4 h-4 mr-2 mt-0.5 text-warm-400 flex-shrink-0" data-id="element-299" />
                    <span data-id="element-300">
                      Please book at least 24 hours in advance for guaranteed
                      availability.
                    </span>
                  </li>
                  <li className="flex items-start" data-id="element-301">
                    <MapPin className="w-4 h-4 mr-2 mt-0.5 text-warm-400 flex-shrink-0" data-id="element-302" />
                    <span data-id="element-303">
                      Rates are calculated based on mileage, time, and level of
                      assistance required.
                    </span>
                  </li>
                  <li className="flex items-start" data-id="element-304">
                    <Info className="w-4 h-4 mr-2 mt-0.5 text-warm-400 flex-shrink-0" data-id="element-305" />
                    <span data-id="element-306">
                      Submitting this form does not guarantee a ride until
                      confirmed by our dispatch team.
                    </span>
                  </li>
                </ul>
              </CardBody>
            </Card>
          </div>
        </div>
      </div>
    </div>;
}